<template>
    <div class="d-flex align-items-center justify-content-center py-5 my-5" v-if="permissionLoader">
        <i class="fa fa-spinner fa-4x fa-pulse py-5 my-5" />
    </div>
    <Error403Page v-else-if="!checkAuthorization(permission, selectedModule)"></Error403Page>
    <div v-else style="margin-top: -1px;">
        <fr-header-nav class="sticky-top" :class="class" style="z-index: 3" :quicklinks="configurationLinks">
            <template v-slot:picker>
                <TimezonePicker v-if="selectedBrand.flags?.timezonePicker" @timezone-changed="reloadView"/>
                <component :is="picker"></component>
            </template>     
            <template v-for="link in links" :key="link.path">
                <a :href="getExternalLink(link.path, link.meta.query)" v-if="link.meta.isUrl" class="nav-link text-white" exact-active-class="active">
                    <i v-if="link.meta.linkIcon" class="fa" :class="'fa-' + link.meta.linkIcon"></i>
                    {{ link.meta.linkTitle || link.meta.title }}
                </a>
                <fr-header-nav-item v-else-if="!link.meta.excludeInRoute"
                    :link="getLink(selectedBrandUri, selectedModule, link.path )" :id="link.name">
                    <i v-if="link.meta.linkIcon" class="fa" :class="'fa-' + link.meta.linkIcon"></i>
                    {{ link.meta.linkTitle || link.meta.title }}
                </fr-header-nav-item>
                <fr-dropdown v-else-if="link.meta.excludeInRoute && menuLinks(link.meta.menu).length">
                    <fr-dropdown-heading no-caret auto-close="outside">
                        <span class="text-white dropdown-toggle d-flex align-items-center nav-link" type="button"
                            :class="activeClass(link.path) ? 'router-link-active active' : ''">
                            <i v-if="link.meta.linkIcon" class="fa" :class="'fa-' + link.meta.linkIcon"></i>&nbsp;
                            {{ link.name || link.meta.title }}
                        </span>
                    </fr-dropdown-heading>
                    <fr-dropdown-group class="dropdown-menu-right">
                        <fr-dropdown-options v-for="menu in menuLinks(link.meta.menu)" :key="menu"
                            :class="activeClass(menu) ? 'bg-purple' : ''" class="dropdownOption p-0">
                            <router-link :to="'/' + selectedBrandUri + '/' + selectedModule + '/' + menu.path"
                                class="text-decoration-none customer-color fw-normal btn-sm  w-100 btn text-start border-0 rounded-0">
                                {{ menu.title }}
                            </router-link>
                        </fr-dropdown-options>
                    </fr-dropdown-group>
                </fr-dropdown>
            </template>

            <template v-slot:config>
                <div v-if="configurationLinks && configurationLinks.length != 0">
                    <fr-dropdown class="w-100">
                        <fr-dropdown-heading light-caret auto-close="outside"
                            class="w-100 d-flex align-items-center py-2">
                            <a class="nav-link text-white" href="#">
                                Config
                            </a>
                        </fr-dropdown-heading>
                        <fr-dropdown-group>
                            <template v-for="item in configurationLinks" :key="item">
                                <router-link :to="{ path: item.link }" class="dropdown-item" v-if="item.selfPage">
                                    {{ item.name }}
                                </router-link>
                                <fr-dropdown-options target='_blank' :href="item.link" v-else>
                                    {{ item.name }}
                                </fr-dropdown-options>

                            </template>

                        </fr-dropdown-group>
                    </fr-dropdown>
                </div>
            </template>

        </fr-header-nav>
        <section v-if="showCxverseBanner && isDashboardHome" class="dashboard-cxverse-banner">
            <button type="button" class="dashboard-cxverse-banner__dismiss" @click="dismissCxverseBanner"
                aria-label="Dismiss announcement">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>

            <div class="dashboard-cxverse-banner__right">
                <div class="dashboard-cxverse-banner__layout">
                    <div class="dashboard-cxverse-banner__left">
                        <div class="dashboard-cxverse-banner__meta">
                            <span class="dashboard-cxverse-banner__badge">NEW</span>
                        </div>

                        <h2 class="dashboard-cxverse-banner__title">
                            <span>Froogal is now</span>
                            <span class="dashboard-cxverse-banner__title-logo-wrap">
                                <img src="@/assets/cxverse-logo-full-light-mode.svg" alt="CXVERSE"
                                    class="dashboard-cxverse-banner__title-logo" /><span
                                    class="dashboard-cxverse-banner__title-dot">.</span>
                            </span>
                            <span>You got us here.</span>
                        </h2>

                        <div class="dashboard-cxverse-banner__actions">
                            <div class="dashboard-cxverse-banner__links">
                                <a class="dashboard-cxverse-banner__cta dashboard-cxverse-banner__cta--blue"
                                    href="https://fgl.ai/rwd8GlP" target="_blank"
                                    rel="noopener noreferrer">
                                    Read your announcement
                                </a>
                                <a class="dashboard-cxverse-banner__link"
href="https://fgl.ai/D7f8mLf"
                                    target="_blank" rel="noopener noreferrer">
                                    Read the public story
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="dashboard-cxverse-banner__switch-actions">
                        <a class="dashboard-cxverse-banner__cta dashboard-cxverse-banner__cta--neon"
                            href="https://dash.cxverse.com" target="_blank" rel="noopener noreferrer"
                            @mousemove="updateCtaGlow" @mouseleave="resetCtaGlow">
                            Try the new CXVERSE experience
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <div v-if="checkAuthorization(this.$route.meta.permission)" class="displaySizeScroller main-page" >
            <div :style="{ 'min-width': screenWidth + 'px' }">
                <router-view :key="viewKey"></router-view>
            </div>
        </div>
        <Error403Page v-else></Error403Page>
    </div>
    <div class="previewMsgBox d-flex d-md-block d-lg-none" style="z-index:9999">
        <div style="font-size: 14px;">
            The dashboard is not yet optimized for Mobile devices. For best experience kindly use Desktop or Laptop.
        </div>
    </div>
</template>
<script>
import {
    FrHeaderNavItem,
    FrHeaderNav,
    FrDropdown,
    FrDropdownGroup,
    FrDropdownHeading,
    FrDropdownOptions
} from "@froogal.ai/ui";
import { storeToRefs } from "pinia";
import { useBrandsStore } from '@/stores/brands';
import { useMerchantsStore } from "@/stores/merchants";
import { useUserProfileStore } from "@/stores/user-profile";
import { usePermissionStore } from "@/stores/permissions";
import Error403Page from "../views/Error403Page.vue";
import TimezonePicker from "@/components/TimezonePicker.vue";

export default {
    name: 'module-layout',
    setup() {
        const brandStore = useBrandsStore();
        const merchantList = useMerchantsStore();
        const { selectedBrandUri, selectedBrandId, selectedBrand } = storeToRefs(brandStore);
        const { selectedBrandMerchants } = storeToRefs(merchantList);
        const { user } = useUserProfileStore();
        const permissionStore = usePermissionStore();
        const { permissionLoader, isBrandAdmin } = storeToRefs(permissionStore);
        const { checkAuthorization } = permissionStore;
        return {
            selectedBrandUri,
            selectedBrandId,
            selectedBrand,
            selectedBrandMerchants,
            user,
            permissionLoader,
            checkAuthorization,
            isBrandAdmin,
            selectedBrand
        };
    },
    data() {
        return {
            showErrorInfo: true,
            screenWidth: screen.width < 500 ? (screen.width * 2 - 30) : '1000',
            viewKey: 0,
            showCxverseBanner: true,
        }
    },
    props: ["subNavigation", "quickLinks", "selectedModule", "class", "picker", "permission"],
    components: {
        FrHeaderNavItem,
        FrHeaderNav,
        FrDropdown,
        FrDropdownGroup,
        FrDropdownHeading,
        FrDropdownOptions,
        Error403Page,
        TimezonePicker
    },
    created() {
        const hiddenUntil = Number(localStorage.getItem("dashboardCxverseBannerHiddenUntil") || 0);
        this.showCxverseBanner = Date.now() >= hiddenUntil;
        window.addEventListener("resize", this.myEventHandler);
    },
    computed: {
        links() {
            return this.subNavigation.filter((a) => {
                if (a.meta.brandUser) {
                    return this.isBrandAdmin && (this.checkAuthorization(a.meta.permission) || a.meta.excludeInRoute);
                } else {
                    return (a.meta.showInNav || (a.meta.isAdmin ? this.user.isAdmin : false)) && (this.checkAuthorization(a.meta.permission) || a.meta.excludeInRoute);
                }
            }).filter( ele => ele.meta.brandFlag ? this.selectedBrand.flags[ele.meta.brandFlag] : true );
        },
        base() {
            return `/${this.selectedBrandUri}/${this.selectedModule}`;
        },
        configurationLinks() {
            return this.quickLinks?.filter(a => this.checkAuthorization(a.permission))
            .filter( a =>  a.brandFlag ? this.selectedBrand.flags[a.brandFlag] : true)
            .map(m => {
                if (m.new) {
                    return {
                        name: m.name,
                        link: '/' + this.selectedBrandUri + m.link,
                        selfPage: true,
                    }
                } else {
                    return {
                        name: m.name,
                        link: this.selectedBrandMerchants.length != 0
                            ? m.link.replace(":id", this.selectedBrandMerchants[0]?.id)
                            : m.link,
                    };
                }
            })
        },
        isDashboardHome() {
            const dashboardPath = `/${this.selectedBrandUri}/dashboard`;
            const currentPath = this.$route.path.replace(/\/+$/, '');
            return this.selectedModule === 'dashboard' && currentPath === dashboardPath;
        }
    },
    methods: {
        menuLinks(list) {
            return list.filter(a =>
                (this.checkAuthorization(a.permission))
            );
        },
        myEventHandler() {
            this.screenWidth = screen.width < 500 ? (screen.width * 2 - 30) : '1000';
        },
        activeClass(item) {
            const itemPath = this.base + (item.path ? '/' + item.path : '');
            if (itemPath == this.$route.path) {
                return true;
            }
        },
        getLink(uri, module, path) {   
            return path ? '/' + uri + '/' + module + '/' + path : '/' + uri + '/' + module;
        },
        getExternalLink(path, query) {
            let queryData = (query || []).map(query => {
                const parts = query.split(':');
                const paramName = parts[0];
                const paramKey = parts[1] || paramName;
                switch (paramName) {
                    case 'brandId':
                        return { [paramKey]: this.selectedBrandId };
                    case 'brandUri':
                        return { [paramKey]: this.selectedBrandUri };
                    default:
                        return {};
                }
            }) 
            const merged = Object.assign({}, ...queryData);
            // Convert to query string
            const queryString = new URLSearchParams(merged).toString();
            if( query.length ) {
                return `${path}?${queryString}`;
            } else {
                return path;
            }
        },
        reloadView() {
            this.viewKey += 1;
        },
        updateCtaGlow(event) {
            const element = event.currentTarget;
            if (!element) return;
            const rect = element.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            element.style.setProperty("--cta-glow-x", `${x}%`);
            element.style.setProperty("--cta-glow-y", `${y}%`);
        },
        resetCtaGlow(event) {
            const element = event.currentTarget;
            if (!element) return;
            element.style.setProperty("--cta-glow-x", "50%");
            element.style.setProperty("--cta-glow-y", "50%");
        },
        dismissCxverseBanner() {
            this.showCxverseBanner = false;
            const threeHoursInMs = 3 * 60 * 60 * 1000;
            localStorage.setItem(
                "dashboardCxverseBannerHiddenUntil",
                String(Date.now() + threeHoursInMs)
            );
        },
    }
};
</script>
<style>
.customer-color,
.customer-color:hover {
    color: black;
}

.bg-purple,
.bg-purple:hover,
.bg-purple .customer-color,
.dropdownOption:active {
    background: #59348b !important;
    color: white !important;
}

.previewMsgBox {
    background-color: #d64135;
    color: #fff;
    padding: 5px 10px;
    border-radius: 10px;
    position: fixed;
    bottom: 5px;
    left: 5px;
    right: 5px;
}

.main-page {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
}

@media screen and (max-width: 1000px) {
    .displaySizeScroller {
        overflow: auto;
    }

    .main-page {
        margin-left:0.25rem;
        margin-right: 0.25rem;
    }
}
.dashboard-cxverse-banner {
    box-sizing: border-box;
    position: relative;
    width: auto;
    margin: 0 1.25rem 12px;
    padding: 16px 18px;
    background: #0a1828;
    border: 1px solid #16283b;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(135, 46, 184, 0.15);
    overflow: hidden;
}

.dashboard-cxverse-banner__right {
    color: #fff;
    width: 100%;
}

.dashboard-cxverse-banner__layout {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr) fit-content(360px);
    align-items: center;
    gap: 16px;
    min-width: 0;
}

.dashboard-cxverse-banner__left {
    min-width: 0;
}

.dashboard-cxverse-banner__meta {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}

.dashboard-cxverse-banner__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 10px;
    background: #8cd756;
    color: #0a1828;
    border: 2px solid #8cd756;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
}

.dashboard-cxverse-banner__title {
    margin: 0 0 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 24px;
    line-height: 1.2;
    font-weight: 700;
}

.dashboard-cxverse-banner__title-logo {
    height: 20px;
    width: auto;
    vertical-align: middle;
    max-width: 100%;
}

.dashboard-cxverse-banner__title-logo-wrap {
    display: inline-flex;
    align-items: center;
    gap: 0;
}

.dashboard-cxverse-banner__title-dot {
    margin-left: 0;
}

.dashboard-cxverse-banner__actions {
    margin-top: 22px;
    display: flex;
    width: 100%;
}

.dashboard-cxverse-banner__links {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    min-width: 0;
}

.dashboard-cxverse-banner__switch-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    max-width: 100%;
}

.dashboard-cxverse-banner__cta {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 2px solid #8cd756;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    white-space: normal;
    overflow-wrap: anywhere;
}

.dashboard-cxverse-banner__cta--neon {
    --cta-glow-x: 50%;
    --cta-glow-y: 50%;
    border-color: #8cd756;
    background-image:
        radial-gradient(circle at var(--cta-glow-x) var(--cta-glow-y), rgba(220, 255, 180, 0.5) 0%, rgba(220, 255, 180, 0) 45%),
        linear-gradient(115deg, #6fbf3d, #8cd756, #b4ef7a, #8cd756, #6fbf3d);
    background-size: 280% 280%;
    background-repeat: no-repeat;
    animation: cxverse-neon-wave 4.8s ease-in-out infinite;
    color: #0a1828;
}

.dashboard-cxverse-banner__cta--blue {
    border-color: #fff;
    background: transparent;
    color: #fff;
}

.dashboard-cxverse-banner__link {
    color: rgba(255, 255, 255, .78);
    font-size: 13px;
    font-weight: 700;
    text-decoration: underline;
}

.dashboard-cxverse-banner__dismiss {
    position: absolute;
    top: 16px;
    right: 18px;
    border: 0;
    background: transparent;
    color: rgba(255, 255, 255, 0.36);
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 12px;
}

.dashboard-cxverse-banner__dismiss:hover {
    color: rgba(255, 255, 255, .58);
}

@keyframes cxverse-neon-wave {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

@media (max-width: 991px) {
    .dashboard-cxverse-banner {
        width: auto;
        max-width: 100%;
        margin: 0 0.625rem 12px;
        padding: 14px;
        overflow-x: hidden;
    }

        .dashboard-cxverse-banner__layout {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
        }
        .dashboard-cxverse-banner__right,
    .dashboard-cxverse-banner__left,
    .dashboard-cxverse-banner__actions,
    .dashboard-cxverse-banner__links,
    .dashboard-cxverse-banner__switch-actions,
    .dashboard-cxverse-banner__cta,
    .dashboard-cxverse-banner__title {
        width: 100%;
        max-width: 100%;
        min-width: 0;
    }

        .dashboard-cxverse-banner__switch-actions {
            justify-content: flex-start;
        }
    .dashboard-cxverse-banner__title {
        font-size: 20px;
    }

    .dashboard-cxverse-banner__title-logo {
        height: 17px;
    }

    .dashboard-cxverse-banner__links {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }

        .dashboard-cxverse-banner__link {
            display: inline-flex;
            align-items: center;
            border: 2px solid #fff;
            border-radius: 6px;
            padding: 10px 14px;
            font-size: 13px;
            font-weight: 700;
            text-decoration: none;
            color: #fff;
            background: transparent;
            box-sizing: border-box;
            justify-content: center;
        }
                                .dashboard-cxverse-banner__cta--blue,
    .dashboard-cxverse-banner__cta--neon {
        justify-content: center;
    }

    .dashboard-cxverse-banner__dismiss {
        top: 12px;
        right: 12px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .dashboard-cxverse-banner__cta--neon {
        animation: none;
    }
}
</style>
